<mat-accordion>
    <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false" style="margin-bottom: 20px">
        <mat-expansion-panel-header>
            <mat-panel-title>Capítulo: {{ capitulo.posicao }} - {{ capitulo.descricao }}</mat-panel-title>
        </mat-expansion-panel-header>

        <div>
            <div fxFlex="100%" fxLayoutGap="20px">
                <div fxLayout="row" fxFlexFill>
                    <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="10">
                        <input matInput type="number" name="numeroBloco_{{pinRandom}}"
                               [(ngModel)]="capitulo.posicao" [max]="listaCapitulos.length" [min]="1" pattern="[0-9]+$"
                               placeholder="Posição" required (change)="onChangePosicao()" [disabled]="camposDesabilitados">
                    </mat-form-field>

                    <mat-form-field fxLayoutGap="20px" fxFlexOffset="20px" fxFlex="100">
                        <input #descricaoBloco matInput maxlength="1000" name="descricaoBloco_{{pinRandom}}"
                               placeholder="Descrição" [(ngModel)]="capitulo.descricao" required [disabled]="camposDesabilitados">
                        <mat-hint align="end">{{ descricaoBloco.value.length }} / 1000</mat-hint>
                    </mat-form-field>


                    <div style="margin-left: 26px;">
                        <mat-checkbox color="primary"
                                      title="Nova Página"
                                      name="capituloNovaPagina_{{pinRandom}}"
                                      [(ngModel)]="capitulo.novaPagina"
                                      style="margin-top: 20px;" [disabled]="camposDesabilitados">
                            Nova Página
                        </mat-checkbox>
                    </div>
                </div>
            </div>
            <div fxFlex="10%" style="margin-top: 18px;margin-left: 26px;">
                <button mat-icon-button
                        *ngIf="!camposDesabilitados"
                        (click)="deletar()"
                        style="padding: 0px;">
                    <mat-icon>delete_forever</mat-icon>
                </button>
            </div>
        </div>

        <div fxLayout="row" fxFlexFill>
            <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" ngModelGroup="grupoLinhasRim_{{pinRandom}}">
                <div *ngFor="let conteudo of capitulo.conteudos; let index = index">
                    <conteudo-rim [conteudo]="conteudo"
                                  [index]="index"
                                  [listaConteudos]="capitulo.conteudos"
                                  [camposDesabilitados]="camposDesabilitados"
                                  [consultasBanco]="consultasBanco">
                    </conteudo-rim>
                </div>
                <div fxLayoutAlign="start center" fxLayoutGap="16px"
                     style="padding-top: 10px; padding-left: 20px;">
                    <div>
                        <button matTooltip="Nova Linha" mat-mini-fab color="primary" (click)="addConteudoRim()"
                                style="width: 100px;border-radius: 5px;" *ngIf="!camposDesabilitados">
                            <mat-icon>add</mat-icon>
                            Conteúdo
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>